module.exports = __webpack_public_path__ + "static/media/menergy.32d08b29.svg";